module.exports = __webpack_public_path__ + "img/violet_084.6f17fe4f.png";